export default __webpack_public_path__ + "locales/el-GR/PreparationPortal.json?hash=3638207bc07f16ad0a897deb523cc0a9";